import {
  ANALYTICS,
  STORE_USER_IDENTIFIER_FOR_ANALYTICS,
} from '../actions/analyticsManager.actions';

const initialState = {
  userIdentifier: null,
  trackPayload: {
    event: null,
    params: null,
    vendor: null,
  },
};

const AnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ANALYTICS:
      return { ...state, trackPayload: action.payload };
    case STORE_USER_IDENTIFIER_FOR_ANALYTICS:
      return { ...state, userIdentifier: action.payload };
    default:
      return state;
  }
};
export default AnalyticsReducer;
